export const translations = {
  en: {
    app_title: "PulseFlow Hospital",
    app_subtitle: "Smart Navigator & Queue System",
    patient_mode: "Patient Kiosk",
    doctor_portal: "Doctor Portal",
    kiosk_mode: "Kiosk Mode",
    mobile_view: "Mobile View",
    language: "Language",

    // Emergency
    emergency_title: "EMERGENCY NOTICE",
    emergency_msg: "If you are experiencing a life-threatening emergency, please contact hospital staff or proceed directly to Emergency/Casualty immediately! Do NOT use this kiosk.",
    proceed_non_emergency: "Proceed — Non-Emergency",
    emergency_help: "I Need Immediate Emergency Help",
    emergency_called: "Emergency team alerted. Please stay where you are — staff are on the way.",

    // Patient info
    patient_info_title: "Patient Information",
    patient_info_subtitle: "Help us set up your visit",
    full_name: "Full Name",
    age: "Age",
    phone: "Phone Number (10 digits)",
    location: "Location / City",
    next_step: "Next Step",
    back: "Back",

    // Consultation type
    consultation_title: "What brings you in today?",
    first_time: "First-Time Consultation",
    first_time_desc: "New patient — let our AI guide you to the right department.",
    follow_up: "Follow-Up Consultation",
    follow_up_desc: "Returning for an existing treatment — search your doctor directly.",
    refund_transfer: "Refund / Transfer Request",
    refund_transfer_desc: "A doctor marked your visit as wrong department — rebook correctly.",

    // AI Triage
    ai_triage_title: "AI Triage Assistant",
    know_disease: "I know my condition",
    know_disease_desc: "Enter the disease or diagnosis name",
    describe_symptoms: "I'll describe my symptoms",
    describe_symptoms_desc: "Tell us what you're feeling and we'll find the right department",
    disease_placeholder: "e.g. Pilonidal Sinus, Asthma, Fracture",
    symptoms_placeholder: "e.g. severe lower back pain, fever for 3 days…",
    analyze: "Analyze with AI",
    analyzing: "Analyzing…",
    recommendations: "Department Recommendations",
    highly_recommended: "Highly Recommended",
    recommended: "Recommended",
    possible: "Possible",
    unrelated: "Unrelated",

    // Booking
    select_doctor: "Select Doctor",
    search_doctor: "Search doctor name or department…",
    all_depts: "All Departments",
    select_slot: "Select Date & Time",
    fee: "Fee",
    pay_now: "Pay with UPI",
    upi_title: "UPI Payment",
    upi_scan: "Scan this QR with any UPI app",
    simulate_pay: "Simulate Payment Successful",
    total: "Total",
    processing: "Processing…",

    // Receipt
    booking_confirmed: "Booking Confirmed",
    sms_sent: "SMS sent to",
    token: "Token",
    doctor: "Doctor",
    department: "Department",
    date_time: "Date & Time",
    patient_name: "Patient",
    new_booking: "New Booking",

    // Refund
    refund_lookup_title: "Lookup Previous Appointment",
    refund_lookup_desc: "Enter your Token Number or Phone Number",
    lookup: "Lookup",
    rejected_notice: "This appointment was marked REJECTED — Wrong Department. You can now rebook correctly.",
    not_rejected_notice: "Only appointments marked REJECTED by a doctor are eligible for transfer rebooking.",
    correct_disease_label: "Correct disease / condition (as told by the doctor)",
    correct_disease_placeholder: "e.g. Colorectal infection",
    rebook_new: "Rebook with correct department",
    refund_success: "100% refund processed",

    // Doctor portal
    doctor_login: "Doctor Login",
    email: "Email",
    password: "Password",
    login: "Login",
    logout: "Logout",
    todays_queue: "Today's OPD Queue",
    schedule: "Schedule",
    profile: "Profile",
    call_patient: "Call Patient",
    complete: "Complete",
    reject_wrong_dept: "Reject — Wrong Dept",
    emergency_cancel: "Emergency Cancel Slot",
    waiting: "Waiting",
    calling: "Calling",
    completed: "Completed",
    rejected: "Rejected",
    cancelled: "Cancelled",
    save: "Save",
    no_appointments: "No appointments for today",
    close_date: "Close this date",
    open_date: "Open this date",
  },
  hi: {
    app_title: "पल्सफ्लो अस्पताल",
    app_subtitle: "स्मार्ट नेविगेटर और कतार प्रणाली",
    patient_mode: "मरीज़ कियोस्क",
    doctor_portal: "डॉक्टर पोर्टल",
    kiosk_mode: "कियोस्क मोड",
    mobile_view: "मोबाइल व्यू",
    language: "भाषा",
    emergency_title: "आपातकालीन सूचना",
    emergency_msg: "यदि आप जीवन के लिए खतरा महसूस कर रहे हैं, तुरंत अस्पताल कर्मचारी से संपर्क करें या सीधे आपातकालीन विभाग में जाएँ! इस कियोस्क का उपयोग न करें।",
    proceed_non_emergency: "आगे बढ़ें — गैर-आपातकालीन",
    emergency_help: "मुझे तुरंत आपातकालीन सहायता चाहिए",
    emergency_called: "आपातकालीन टीम को सूचित कर दिया गया है। कृपया वहीं रहें।",
    patient_info_title: "मरीज़ की जानकारी",
    patient_info_subtitle: "अपनी यात्रा सेट करने में हमारी मदद करें",
    full_name: "पूरा नाम",
    age: "उम्र",
    phone: "फ़ोन नंबर (10 अंक)",
    location: "स्थान / शहर",
    next_step: "अगला चरण",
    back: "वापस",
    consultation_title: "आज आप किस कारण से आए हैं?",
    first_time: "पहली बार परामर्श",
    first_time_desc: "नए मरीज़ — हमारा AI आपको सही विभाग में भेजेगा।",
    follow_up: "फ़ॉलो-अप परामर्श",
    follow_up_desc: "पुराने उपचार के लिए वापस — सीधे डॉक्टर खोजें।",
    refund_transfer: "रिफंड / स्थानांतरण",
    refund_transfer_desc: "डॉक्टर ने ग़लत विभाग चिह्नित किया — सही से बुक करें।",
    ai_triage_title: "AI ट्राइएज सहायक",
    know_disease: "मुझे अपनी बीमारी पता है",
    know_disease_desc: "रोग का नाम दर्ज करें",
    describe_symptoms: "मैं लक्षण बताऊंगा",
    describe_symptoms_desc: "अपने लक्षण बताएं, हम सही विभाग खोजेंगे",
    disease_placeholder: "जैसे पायलोनिडल साइनस, अस्थमा, फ्रैक्चर",
    symptoms_placeholder: "जैसे पीठ में तेज़ दर्द, 3 दिन से बुखार…",
    analyze: "AI से विश्लेषण करें",
    analyzing: "विश्लेषण हो रहा है…",
    recommendations: "विभाग सुझाव",
    highly_recommended: "अत्यधिक अनुशंसित",
    recommended: "अनुशंसित",
    possible: "संभावित",
    unrelated: "असंबंधित",
    select_doctor: "डॉक्टर चुनें",
    search_doctor: "डॉक्टर या विभाग खोजें…",
    all_depts: "सभी विभाग",
    select_slot: "दिनांक और समय चुनें",
    fee: "शुल्क",
    pay_now: "UPI से भुगतान",
    upi_title: "UPI भुगतान",
    upi_scan: "किसी भी UPI ऐप से QR स्कैन करें",
    simulate_pay: "भुगतान सफल अनुकरण",
    total: "कुल",
    processing: "प्रोसेसिंग…",
    booking_confirmed: "बुकिंग पुष्टि",
    sms_sent: "SMS भेजा गया",
    token: "टोकन",
    doctor: "डॉक्टर",
    department: "विभाग",
    date_time: "दिनांक और समय",
    patient_name: "मरीज़",
    new_booking: "नई बुकिंग",
    refund_lookup_title: "पिछली अपॉइंटमेंट खोजें",
    refund_lookup_desc: "टोकन नंबर या फ़ोन नंबर दर्ज करें",
    lookup: "खोजें",
    rejected_notice: "यह अपॉइंटमेंट अस्वीकृत — गलत विभाग के रूप में चिह्नित है।",
    not_rejected_notice: "केवल डॉक्टर द्वारा अस्वीकृत अपॉइंटमेंट पुनः बुक की जा सकती हैं।",
    correct_disease_label: "सही बीमारी (डॉक्टर द्वारा बताई गई)",
    correct_disease_placeholder: "जैसे कोलोरेक्टल संक्रमण",
    rebook_new: "सही विभाग से पुनः बुक करें",
    refund_success: "100% रिफंड सफल",
    doctor_login: "डॉक्टर लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    login: "लॉगिन",
    logout: "लॉगआउट",
    todays_queue: "आज की कतार",
    schedule: "शेड्यूल",
    profile: "प्रोफ़ाइल",
    call_patient: "मरीज़ बुलाएँ",
    complete: "पूर्ण",
    reject_wrong_dept: "अस्वीकृत — गलत विभाग",
    emergency_cancel: "आपातकालीन रद्द",
    waiting: "प्रतीक्षा",
    calling: "बुला रहे",
    completed: "पूर्ण",
    rejected: "अस्वीकृत",
    cancelled: "रद्द",
    save: "सहेजें",
    no_appointments: "आज कोई अपॉइंटमेंट नहीं",
    close_date: "यह दिनांक बंद करें",
    open_date: "यह दिनांक खोलें",
  },
  ta: {
    app_title: "பல்ஸ்ஃப்ளோ மருத்துவமனை",
    app_subtitle: "ஸ்மார்ட் வழிகாட்டி மற்றும் வரிசை அமைப்பு",
    patient_mode: "நோயாளி கியோஸ்க்",
    doctor_portal: "மருத்துவர் போர்டல்",
    kiosk_mode: "கியோஸ்க் முறை",
    mobile_view: "மொபைல் காட்சி",
    language: "மொழி",
    emergency_title: "அவசர அறிவிப்பு",
    emergency_msg: "உயிருக்கு ஆபத்தான அவசரநிலையை அனுபவித்தால், உடனடியாக ஊழியர்களை தொடர்பு கொள்ளவும்! இந்த கியோஸ்க்கை பயன்படுத்த வேண்டாம்.",
    proceed_non_emergency: "தொடரவும் — அவசரமற்றது",
    emergency_help: "எனக்கு உடனடி அவசர உதவி தேவை",
    emergency_called: "அவசர குழு எச்சரிக்கப்பட்டது. அங்கேயே இருங்கள்.",
    patient_info_title: "நோயாளி விவரம்",
    patient_info_subtitle: "உங்கள் வருகையை அமைக்க உதவுங்கள்",
    full_name: "முழு பெயர்",
    age: "வயது",
    phone: "தொலைபேசி எண் (10 இலக்கங்கள்)",
    location: "இடம் / நகரம்",
    next_step: "அடுத்த படி",
    back: "பின்",
    consultation_title: "இன்று என்ன காரணம்?",
    first_time: "முதல் முறை ஆலோசனை",
    first_time_desc: "புதிய நோயாளி — AI உங்களுக்கு வழிகாட்டும்.",
    follow_up: "தொடர் ஆலோசனை",
    follow_up_desc: "ஏற்கனவே உள்ள சிகிச்சை — நேரடியாக மருத்துவரை தேடுங்கள்.",
    refund_transfer: "பணத்திருப்பம் / மாற்றம்",
    refund_transfer_desc: "மருத்துவர் தவறான துறை என குறித்தார் — சரியாக பதிவு செய்யுங்கள்.",
    ai_triage_title: "AI ட்ரையேஜ் உதவியாளர்",
    know_disease: "எனக்கு நோய் தெரியும்",
    know_disease_desc: "நோயின் பெயரை உள்ளிடவும்",
    describe_symptoms: "அறிகுறிகளை விவரிப்பேன்",
    describe_symptoms_desc: "அறிகுறிகளை சொல்லுங்கள், சரியான துறையை கண்டுபிடிப்போம்",
    disease_placeholder: "எ.கா. பைலோனிடல் சைனஸ், ஆஸ்துமா, எலும்பு முறிவு",
    symptoms_placeholder: "எ.கா. கடுமையான முதுகுவலி, 3 நாட்களாக காய்ச்சல்…",
    analyze: "AI உடன் பகுப்பாய்வு",
    analyzing: "பகுப்பாய்வு…",
    recommendations: "துறை பரிந்துரைகள்",
    highly_recommended: "மிகவும் பரிந்துரை",
    recommended: "பரிந்துரை",
    possible: "சாத்தியம்",
    unrelated: "தொடர்பில்லை",
    select_doctor: "மருத்துவர் தேர்வு",
    search_doctor: "மருத்துவர் அல்லது துறை தேடுங்கள்…",
    all_depts: "அனைத்து துறைகள்",
    select_slot: "தேதி & நேரம் தேர்வு",
    fee: "கட்டணம்",
    pay_now: "UPI பணம் செலுத்து",
    upi_title: "UPI பணம்",
    upi_scan: "எந்த UPI செயலியிலும் QR ஸ்கேன் செய்யுங்கள்",
    simulate_pay: "பணம் வெற்றிகரமாக உருவகப்படுத்து",
    total: "மொத்தம்",
    processing: "செயலாக்கம்…",
    booking_confirmed: "பதிவு உறுதி",
    sms_sent: "SMS அனுப்பப்பட்டது",
    token: "டோக்கன்",
    doctor: "மருத்துவர்",
    department: "துறை",
    date_time: "தேதி & நேரம்",
    patient_name: "நோயாளி",
    new_booking: "புதிய பதிவு",
    refund_lookup_title: "முந்தைய பதிவை தேடுங்கள்",
    refund_lookup_desc: "டோக்கன் அல்லது தொலைபேசி எண் உள்ளிடவும்",
    lookup: "தேடு",
    rejected_notice: "இந்த பதிவு நிராகரிக்கப்பட்டது — தவறான துறை.",
    not_rejected_notice: "மருத்துவரால் நிராகரிக்கப்பட்ட பதிவுகள் மட்டுமே மறுபதிவுக்கு தகுதி.",
    correct_disease_label: "சரியான நோய் (மருத்துவர் சொன்னது)",
    correct_disease_placeholder: "எ.கா. கொலொரெக்டல் தொற்று",
    rebook_new: "சரியான துறையுடன் மறுபதிவு",
    refund_success: "100% பணத்திருப்பம் முடிந்தது",
    doctor_login: "மருத்துவர் உள்நுழைவு",
    email: "மின்னஞ்சல்",
    password: "கடவுச்சொல்",
    login: "உள்நுழைய",
    logout: "வெளியேறு",
    todays_queue: "இன்றைய வரிசை",
    schedule: "அட்டவணை",
    profile: "சுயவிவரம்",
    call_patient: "நோயாளியை அழை",
    complete: "முடிந்தது",
    reject_wrong_dept: "நிராகரி — தவறான துறை",
    emergency_cancel: "அவசர ரத்து",
    waiting: "காத்திருப்பு",
    calling: "அழைக்கிறது",
    completed: "முடிந்தது",
    rejected: "நிராகரிக்கப்பட்டது",
    cancelled: "ரத்து",
    save: "சேமி",
    no_appointments: "இன்று பதிவுகள் இல்லை",
    close_date: "இந்த தேதியை மூடு",
    open_date: "இந்த தேதியை திற",
  },
};
